import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { getLoggedIn } from "../modules/Auth/authSelectors.js";
import RoutePaths from "./routePaths.js";

export const getRender = (props, component, loggedIn, wrapper = null) => {
    const element = React.createElement(component, props);
    const wrapperElement = wrapper ? React.createElement(wrapper, props, element) : element;
    if (!loggedIn) {
        return wrapperElement;
    }
    return <Fragment>
        {
            wrapperElement
        }
    </Fragment>;
};

const PrivateRoute = ({ component, wrapper, wrapperProps, ...rest }) => {
    const loggedIn = useSelector(getLoggedIn);
    if (!loggedIn) {
        return <Redirect to={RoutePaths.login}/>;
    }
    return <Route {...rest} render={(props) => (
        getRender({ ...props, ...wrapperProps }, component, loggedIn, wrapper)
    )}/>;
};

export default PrivateRoute;
